goog.provide("shadow.js.shim.module$src$svg$artwork$retro_tv_svg$default");
shadow.js.shim.module$src$svg$artwork$retro_tv_svg$default = shadow.js.shim.module$src$svg$artwork$retro_tv_svg.default;
